import React, { type ReactNode, useEffect, useCallback } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import { Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import {
	useAnalyticsEvents,
	fireScreenAnalytics,
	fireUIAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { DATA_PRIVACY_LINK } from '../constants.tsx';
import messages from '../messages.tsx';

const AdControlsReasonsModal = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	useEffect(() => {
		fireScreenAnalytics(createAnalyticsEvent({}));
	}, [createAnalyticsEvent]);

	const clickedLinkBaseEvent = createAnalyticsEvent({
		action: 'clicked',
		actionSubject: 'link',
	});

	const onClickPrivacyPolicy = useCallback(() => {
		fireUIAnalytics(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
	}, [clickedLinkBaseEvent]);

	return (
		<>
			{formatMessage(messages.reasonsModalExplanation, {
				strong: (chunks: ReactNode[]) => <Text as="strong">{chunks}</Text>,
			})}
			<BulletPoints>
				<li>{formatMessage(messages.reasonsModalBulletOne)}</li>
				<li>{formatMessage(messages.reasonsModalBulletTwo)}</li>
			</BulletPoints>
			<Button
				appearance="link"
				spacing="none"
				href={DATA_PRIVACY_LINK}
				target="_blank"
				onClick={onClickPrivacyPolicy}
				interactionName="auto-generated.jira-issue-view-base.content.confluence-placeholder-template-experiment.common.ad-controls.button"
			>
				{formatMessage(messages.privacyPolicy)}
			</Button>
		</>
	);
};

export default AdControlsReasonsModal;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BulletPoints = styled.ul({
	marginBottom: token('space.150'),
});
